/**
 * Contact HubSpot form: move long empty-value first options onto the
 * field label so native <select>s are not clipped. Reuses HubSpot copy.
 */
(function () {
	"use strict";

	var root = document.querySelector(".contact-page .bm_form");
	if (!root) {
		return;
	}

	function promoteSelectLabels(form) {
		var fields = form.querySelectorAll(".hs-fieldtype-select");
		fields.forEach(function (field) {
			var select = field.querySelector("select");
			var labelSpan = field.querySelector(":scope > label span");
			if (!select || !select.options.length || !labelSpan) {
				return;
			}
			if (labelSpan.textContent.trim() !== "") {
				return;
			}
			var first = select.options[0];
			var text = (first.textContent || "").trim();
			if (text === "" || first.value !== "") {
				return;
			}
			labelSpan.textContent = text;
			first.textContent = "";
		});
	}

	function tryPromote() {
		var form = root.querySelector("form");
		if (!form || form.getAttribute("data-b5st-select-labels") === "1") {
			return false;
		}
		if (!form.querySelector(".hs-fieldtype-select")) {
			return false;
		}
		form.setAttribute("data-b5st-select-labels", "1");
		promoteSelectLabels(form);
		return true;
	}

	if (tryPromote()) {
		return;
	}

	var observer = new MutationObserver(function () {
		if (tryPromote()) {
			observer.disconnect();
		}
	});
	observer.observe(root, { childList: true, subtree: true });
})();
